// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqKettlebellSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqKettleBellSVG(props: Props) {
  const {fill, width = 24, height = 24} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M6.02959 9.266L5.42159 4.372C5.36883 3.94982 5.40648 3.52124 5.53203 3.11471C5.65759 2.70819 5.86818 2.33303 6.14982 2.01412C6.43146 1.69522 6.77772 1.43986 7.1656 1.26502C7.55349 1.09018 7.97412 0.999837 8.39959 1H15.5996C16.0249 1.00012 16.4453 1.09067 16.8329 1.26564C17.2206 1.44061 17.5666 1.696 17.848 2.01487C18.1294 2.33374 18.3399 2.70881 18.4653 3.11519C18.5907 3.52157 18.6283 3.94998 18.5756 4.372L17.9696 9.266"
        stroke={fill}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.34805 23.0016H17.648C19.0973 21.8328 20.1484 20.2432 20.6565 18.4519C21.1646 16.6607 21.1046 14.756 20.4848 13.0002C19.865 11.2445 18.716 9.72424 17.196 8.6489C15.676 7.57355 13.8599 6.99609 11.998 6.99609C10.1361 6.99609 8.32007 7.57355 6.8001 8.6489C5.28012 9.72424 4.13107 11.2445 3.5113 13.0002C2.89152 14.756 2.83153 16.6607 3.33959 18.4519C3.84765 20.2432 4.89876 21.8328 6.34805 23.0016Z"
        stroke={fill}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19Z"
        stroke={fill}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
}

export default EqKettleBellSVG;
